import React, {useState, useEffect} from "react";
import {INPUT_TYPE_TEXT} from "../../../constants/input-types";
import {INPUT_TYPE_DATE} from "../../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../../constants/input-types";
import {INPUT_TYPE_HIDDEN} from "../../../constants/input-types";
import {INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION} from "../../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../../constants/input-types";
import EditPanelInputText from '../components/EditPanelInputText';
import EditPanelInputTextArea from '../components/EditPanelInputTextArea';
import EditPanelInputSelect from '../components/EditPanelInputSelect';
import EditPanelInputSelectWithChangeFunction from '../components/EditPanelInputSelectWithChangeFunction';
import EditPanelInputSelectFromDb from '../components/EditPanelInputSelectFromDb';
import EditPanelInputSelectFromDbConcatenation from '../components/EditPanelInputSelectFromDbConcatenation';
import EditPanelInputDate from '../components/EditPanelInputDate';

export default function EditPanel({title, componentRows}){
	
	
	useEffect(() => {
		
	}, [componentRows]);
	
	const mainEditPanel = {
		display:"flex",
		width:"calc(50% - 40px)",
		backgroundColor:"#fff",
		borderRadius:"10px",
		minHeight:"calc(100vh - 280px)",
		marginLeft:"30px",
		flexDirection:"column",
		paddingBottom:"30px"
	};
	
	const titlePanel = {
		display:'flex',
		width:"100%",
		alignItems:"center",
		justifyContent:"space-around",
		color:"black",
		height:"40px",
		fontSize:"14px",
		fontWeight:"bold"
	};
	
	const editRow = {
		display:"flex",
		minHeight:"40px",
		alignItems:"center"
	};
	
	const editTitle = {
		display:"flex",
		width:"150px",
		fontSize:"12px",
		paddingLeft:"20px"
	};
	
	const getInputDisplay = (inputType, ref, options, restUrl, changeFunction) => {
		if(inputType === INPUT_TYPE_TEXT){
			return <EditPanelInputText thisRef={ref}/>
		}	
		else if(inputType === INPUT_TYPE_TEXTAREA){
			return <EditPanelInputTextArea thisRef={ref}/>
		}	
		else if(inputType === INPUT_TYPE_SELECT){
			return <EditPanelInputSelect thisRef={ref} options={options}/>
		}	
		else if(inputType === INPUT_TYPE_SELECT_WITH_CHANGE_FUNCTION){
			return <EditPanelInputSelectWithChangeFunction thisRef={ref} options={options} changeFunction={changeFunction}/>
		}	
		else if(inputType === INPUT_TYPE_SELECTFROMDB){
			return <EditPanelInputSelectFromDb thisRef={ref} options={options} restUrl={restUrl}/>
		}	
		else if(inputType === INPUT_TYPE_SELECTFROMDBCONCATENATION){
			return <EditPanelInputSelectFromDbConcatenation thisRef={ref} options={options} restUrl={restUrl}/>
		}	
		else if(inputType === INPUT_TYPE_DATE){
			return <EditPanelInputDate thisRef={ref}/>
		}	
		
		else{
			return "n/a"
		}	
	};
	
	const getDisplay = (inputType) => {
		if(inputType === INPUT_TYPE_HIDDEN){
			return "none";
		}
		else{
			return "flex";
		}
	};
	
	const componentRowDisplay = componentRows.map((item, index) => 
		<div style={{...editRow, display:getDisplay(item.inputType)}}>
			<div style={editTitle}>
				{item.title}
			</div>
			{getInputDisplay(item.inputType, item.ref, item.options, item.restUrl, item.changeFunction)}
		</div>
	);
	
	return (
		<div style={mainEditPanel}>
			<div style={titlePanel}>
				{title}
			</div>
			{componentRowDisplay}
		</div>
		
	);
}